/**
 * priceValidationUtils.js
 * 価格関連定数とバリデーション関数
 * PriceServiceと統一された価格処理ユーティリティ
 * フェーズ1: 基本単価機能専用
 */

// 🔹 価格関連定数（PriceServiceと統一）
export const PRICE_CONSTANTS = {
  SCALE: 4, // 小数点以下4桁
  MAX_VALUE: 9999999.9999, // 最大値
  MIN_VALUE: 0, // 最小値（0以上）
  REGEX: /^\d+(\.\d{1,4})?$/ // 数値パターン（小数点以下4桁まで）
};

/**
 * 標準価格バリデーション関数（PriceServiceと統一）
 * @param {string} value - 検証対象の価格文字列
 * @returns {string|null} - エラーメッセージまたはnull
 */
export const validateStandardUnitPrice = (value) => {
  // 空欄は許可（任意項目）
  if (!value || value.trim() === '') {
    return null;
  }

  // 数値パターンチェック（PriceService.PRICE_SCALEと統一）
  if (!PRICE_CONSTANTS.REGEX.test(value)) {
    return `数値で入力してください（小数点以下${PRICE_CONSTANTS.SCALE}桁まで）`;
  }

  const numValue = parseFloat(value);
  
  // PriceService.isValidPrice()と統一：0以上
  if (numValue < PRICE_CONSTANTS.MIN_VALUE) {
    return `${PRICE_CONSTANTS.MIN_VALUE}以上で入力してください`;
  }
  
  // 上限チェック
  if (numValue > PRICE_CONSTANTS.MAX_VALUE) {
    return `上限（${PRICE_CONSTANTS.MAX_VALUE.toLocaleString()}）を超えています`;
  }
  
  return null;
};

/**
 * 価格の表示用フォーマット関数
 * @param {number|string} price - フォーマット対象の価格
 * @returns {string} - フォーマット済みの価格文字列
 */
export const formatPrice = (price) => {
  if (price == null || price === '') return '';
  const numPrice = typeof price === 'string' ? parseFloat(price) : price;
  return numPrice.toLocaleString('ja-JP', {
    minimumFractionDigits: 0,
    maximumFractionDigits: PRICE_CONSTANTS.SCALE
  });
};

/**
 * 全角数字を半角に変換
 * @param {string} value - 変換対象の文字列
 * @returns {string} - 半角数字に変換された文字列
 */
export const normalizeNumericInput = (value) => {
  return value.replace(/[０-９]/g, (s) => 
    String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
  );
};

/**
 * API送信用の価格データ準備
 * @param {string} priceString - 価格文字列
 * @returns {number|null} - API用の数値またはnull
 */
export const preparePriceForAPI = (priceString) => {
  return priceString ? parseFloat(priceString) : null;
};

// フェーズ1専用：税抜き価格のみ対応
// フェーズ2以降で以下の税計算関数を追加予定:
// - calculateLightOilTax() - 軽油引取税
// - calculatePetroleumCoalTax() - 石油石炭税
// - calculateConsumptionTax() - 消費税
// - calculateTotalTaxIncludedPrice() - 税込み総額